"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
var Common;
(function (Common) {
    let PostStatusEnum;
    (function (PostStatusEnum) {
        PostStatusEnum[PostStatusEnum["Any"] = 0] = "Any";
        PostStatusEnum[PostStatusEnum["Pending"] = -1] = "Pending";
        PostStatusEnum[PostStatusEnum["Delete"] = -2] = "Delete";
        PostStatusEnum[PostStatusEnum["Cancelled"] = -3] = "Cancelled";
        PostStatusEnum[PostStatusEnum["Disabled"] = -4] = "Disabled";
        PostStatusEnum[PostStatusEnum["Active"] = 1] = "Active";
    })(PostStatusEnum = Common.PostStatusEnum || (Common.PostStatusEnum = {}));
})(Common || (exports.Common = Common = {}));
